<template>
    <div class="merged-page">
        <div class="route-page-content">
            <AutomationMenu v-model="selectedTab" />
            <div class="page-content-wrapper">
                <AutomationList v-if="isSelected('all-automations')" />
                <AutomationList v-if="isSelected('scheduled-automations')" type="timer" />
                <AutomationList v-if="isSelected('event-based-automations')" type="event" />
                <AutomationList v-if="isSelected('button-automations')" type="button" />
                <AutomationList v-if="isSelected('webhook-automations')" type="webhook" />
                <AutomationGeneralInsights v-if="isSelected('automation-insights')" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import AutomationMenu from "./AutomationMenu.vue";
import AutomationList from "./pages/automations/AutomationList.vue";
import AutomationGeneralInsights from "./pages/automations/AutomationGeneralInsights.vue";
import AutomationMenuItems from "./AutomationMenuItems";
import Modal2 from "../../../components/common/Modal2.vue";
import * as _ from "lodash";

const log = log2("Automation");
export default {
    name: "Automation",
    components: {
        Modal2,
        AutomationMenu,
        AutomationList,
        AutomationGeneralInsights,
    },
    data() {
        return {
            defaultPath: this.$route.path,
            selectedTab: this.$route.path.replace(/(\/automations\/|\/automations)/g, "") || "all-automations",
        };
    },
    computed: {
        ...mapState({
            isAdmin: (state) => state.auth.adminUser != null,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        isSelected(type) {
            const items = AutomationMenuItems(this);
            const item = items.find((item) => item?.parentKey === this.selectedTab || item.key === this.selectedTab);
            return item.key === type || item.parentKey === type;
        },
        setDefaultPath: _.debounce(function () {
            this.defaultPath = this.$route.path;
        }, 0),
        init() {
            this.selectedTab = this.defaultPath.replace(/(\/automations\/|\/automations)/g, "") || "all-automations";
            const selected = AutomationMenuItems(this).find((x) => x.key === this.selectedTab);
            if (!selected?.enabled) {
                const available = AutomationMenuItems(this).find((x) => x.enabled);
                if (available) {
                    this.selectedTab = available.key;
                } else {
                    this.$router.push("/denied");
                }
            }
        },
    },
    created() {
        this.init();
    },
    watch: {
        selectedTab(newVal) {
            this.$router.push(`/automations/${newVal}`);
        },
        "$route.path": {
            deep: true,
            handler(val) {
                this.setDefaultPath(val);
            },
        },
        defaultPath(val) {
            this.init(val);
        },
    },
};
</script>
<style lang="scss"> 

</style>